import { ApiProperty } from '@nestjs/swagger';
import { OffsetPaginationResponseDto } from '@sphere/shared/domain';
import { ActivityBaseResponseDto } from './activity-base.response';

export class ActivityListResponseDto extends OffsetPaginationResponseDto<ActivityBaseResponseDto> {
  @ApiProperty({ 
    type: () => ActivityBaseResponseDto, // Type d'un item
    isArray: true,                       // Précise que c'est un tableau
    description: 'Liste des activités' 
  })
  data: ActivityBaseResponseDto[]; // Enlève "declare" ici si possible
}